import { render, staticRenderFns } from "./campo.vue?vue&type=template&id=b97c30c0"
import script from "./campo.ts?vue&type=script&lang=js&external"
export * from "./campo.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\TafStore.PharmUP.Client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b97c30c0')) {
      api.createRecord('b97c30c0', component.options)
    } else {
      api.reload('b97c30c0', component.options)
    }
    module.hot.accept("./campo.vue?vue&type=template&id=b97c30c0", function () {
      api.rerender('b97c30c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/printModel/campo.vue"
export default component.exports